import { IStateProvider } from 'angular-ui-router';
import { USER_ROLE_PERMISSIONS_FOR_STATES } from '../../../ng2/shared/constants/user-role-permissions-for-states.constant';
import { SpinnerModal } from './../../shared/modals/status-spinner/status-spinner.service';

export function callbackRoute($stateProvider: IStateProvider) {
  /**
   * When a user is authenticated by Auth0, they are redirected to this route.
   * We intentionally leave this route free of any logic so that the `Auth#handleAuthentication` method
   * invocation in the `app.run` can redirect the user to `main.home` or `lastKnownUrl` if
   * the user successfully authenticates (CM).
   */
  $stateProvider.state('callback', {
    url: '/callback',
    onEnter(SpinnerModal: SpinnerModal) {
      SpinnerModal.activateSpinner('Loading...');
    },
    data: {
      roles: USER_ROLE_PERMISSIONS_FOR_STATES.callback,
    },
  });
}
